import React, { useState } from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";
import SyntaxHighlighter from "react-syntax-highlighter";
import { atomOneDark } from "react-syntax-highlighter/dist/esm/styles/hljs";
import Clipboard from "@react-native-clipboard/clipboard";
import { NormalText } from "../../../common/native";

type CopyableCodeBlockProps = {
  code: string;
};

const CopyableCodeBlock: React.FC<CopyableCodeBlockProps> = ({ code }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    Clipboard.setString(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <View style={styles.codeBlockContainer}>
      <SyntaxHighlighter language="javascript" style={atomOneDark}>
        {code}
      </SyntaxHighlighter>
      <TouchableOpacity style={styles.copyButton} onPress={handleCopy}>
        <NormalText
          text={copied ? "Copied" : "Copy"}
          style={{ fontSize: 12, textAlign: "center" }}
        />
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  codeBlockContainer: {
    position: "relative",
  },
  copyButton: {
    position: "absolute",
    bottom: 20,
    right: 10,
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    padding: 5,
    borderRadius: 5,
    width: 60,
  },
});

export default CopyableCodeBlock;
